import React from "react";
import { useExposedProps } from "zudoku/hooks";

export default function Link({ to, children, ...props }) {
  const { navigate } = useExposedProps();
  return (
    <button
      {...props}
      onClick={() => {
        // Assuming `navigate` is a function that handles navigation
        navigate(to);
      }}
      className="text-blue-500 hover:underline"
    >
      {children}
    </button>
  );
}
